import axios from "axios";
import { API_BASE } from "../utils/api";
import { DeepgramTokenResponse } from "../types/transcript";

// Mints a short-lived Deepgram token via the Django backend. The master
// Deepgram key never reaches the browser — only the short-TTL JWT returned
// here, used to open the Deepgram live-listen WebSocket directly.
//
// Auth (Cognito Bearer + 401 refresh) is applied by the global axios
// interceptors in utils/api.ts.
const deepgramService = {
  // patientId is sent for the HIPAA audit trail only (recording-start entry);
  // the token itself is not patient-scoped.
  getDeepgramToken: async (
    languageCode: string,
    patientId?: number | null
  ): Promise<DeepgramTokenResponse> => {
    const { data } = await axios.post<DeepgramTokenResponse>(
      `${API_BASE}/soap-notes/deepgram/token/`,
      {
        language: languageCode,
        ...(patientId != null ? { patient_id: patientId } : {}),
      }
    );
    return data;
  },
};

export default deepgramService;
